import React from 'react';
import PropTypes from 'prop-types';
import {Link} from '@gravity-ui/uikit';
import cn from 'bem-cn-lite';

import Icon from '../../components/Icon/Icon';
import i18n from './i18n';

import './HelpLink.scss';

const propTypes = {
    url: PropTypes.string.isRequired,
    text: PropTypes.string,
};

const block = cn('yt-help-link');

interface Props {
    url?: string;
    text?: string;
}

function HelpLink({url, text = i18n('value_help')}: Props) {
    return !url ? null : (
        <Link href={url} target="_blank" title={i18n('title_view-documentation')}>
            <Icon awesome="book" size={14} />
            {text && <span className={block('text')}>{text}</span>}
        </Link>
    );
}

HelpLink.propTypes = propTypes;

export default HelpLink;
